export type TreeSearchFunction = {
  <T extends Record<string, any>, K extends string = 'children'>(
    arr: T[],
    childrenKey: K,
    predicate: (
      val: T,
      options?: {
        depth?: number;
        parent?: T;
        index?: number;
        path?: T[];
        indexPath?: number[];
      },
    ) => boolean,
  ): T | undefined;
};

export const treeSearch: TreeSearchFunction = <
  T extends Record<string, any>,
  K extends string = 'children',
>(
  arr: T[],
  childrenKey: K,
  predicate: (
    val: T,
    options?: {
      depth?: number;
      parent?: T;
      index?: number;
      path?: T[];
      indexPath?: number[];
    },
  ) => boolean,
): T | undefined => {
  let result: T | undefined = undefined;

  const inner = (
    arr: T[] = [],
    depth: number = 0,
    parent?: T,
    path: T[] = [],
    indexPath: number[] = [],
  ): void => {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      const children = item[childrenKey] as T[] | undefined; // Type assertion here

      const options = {
        depth,
        parent,
        index: i,
        path: [...path, item],
        indexPath: [...indexPath, i],
      };

      if (predicate(item, options)) {
        result = item;
        return;
      }

      if (children?.length) {
        inner(children, depth + 1, item, [...path, item], [...indexPath, i]);
        if (result) return;
      }
    }
  };

  inner(arr);
  return result;
};